import { h } from 'preact'
import { Message } from '../../../../../lib/intl/Message'
import { InfoHeading } from '../shared'
import { Geografi, isGeografi, isParti, Parti } from '../../../../domain'
import { Link } from '../../../shared/Link'
import { createUrlFor } from '../../../../routes'
import { useLocale } from '../../../../../lib/intl/IntlProvider'
import { getParentKey } from '../../../shared/geografi'
import { useAppState } from '../../../../../lib/redux-provider-nohooks'
import styles from './FylkesvalgIKommuneInfo.module.css'

type Props = {
  geografi: Geografi
  parent: Geografi
}

export function FylkesvalgIKommuneInfo({ geografi, parent }: Props) {
  if (!geografi.parent) {
    return null
  }
  const locale = useLocale()
  return (
    <section class={styles.fylkesvalgIKommune}>
      <InfoHeading id="info-fylkesvalg-i-kommune-tittel" />
      <Message
        id="info-fylkesvalg-i-kommune-beskrivelse"
        values={{ kommune: geografi.navn, fylke: geografi.parent.navn }}
      />{' '}
      <Link href={createUrlFor(parent, locale)} linkClickType="FYLKESVALG-I-KOMMUNE">
        <Message id="info-fylkesvalg-i-kommune-lenketekst" />
      </Link>
    </section>
  )
}

function getParent(currentPage: Geografi | Parti, grunndata) {
  if (!isGeografi(currentPage)) {
    return
  }
  const parentKey = getParentKey(currentPage)
  return grunndata.geografi.find(geo => geo.key === parentKey)
}

export function ConnectedFylkesvalgIKommuneInfo() {
  const { page, grunndata } = useAppState()
  const currentPage = page.current
  if (!isGeografi(currentPage)) {
    return null
  }

  const parent = getParent(currentPage, grunndata)
  return <FylkesvalgIKommuneInfo geografi={currentPage} parent={parent} />
}
